/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

// Pure predicate for whether a toasted notification should have its readAt
// persisted to RTDB when the toast leaves the screen (auto-dismiss OR manual
// close). Extracted from NotificationToast so it's unit-testable without the
// framer-motion component (CLAUDE.md DI rule).
//
// The re-pop bug: auto-dismiss used to drop the toast from the local queue
// WITHOUT marking it read, so an unread inbox item re-surfaced on every login
// (seenIds is per-mount, so a fresh session no longer suppressed it). Both the
// auto-dismiss and manual paths must now persist readAt — but only for a real
// RTDB-backed node. A foreground-FCM-only toast has a synthetic `fcm_*` id with
// no RTDB node to write, so it must be skipped.

/**
 * True when `notifId` refers to a real /safeCircleNotifications node whose
 * readAt should be persisted. False for empty ids and synthetic `fcm_*` ids.
 */
export function shouldPersistToastRead(
  notifId: string | null | undefined,
): boolean {
  if (!notifId) return false;
  return !notifId.startsWith("fcm_");
}
